import React, { FC } from 'react';

// Utils
import { classNames } from '@sportal365/smp-widget-utils';

interface Props {
  value: string;
  locator: string;
  isHighlighted: boolean;
}

export const StatisticHighlightedValue: FC<Props> = ({ value, locator, isHighlighted }) => {
  return (
    <span
      className={classNames(
        {
          'text-4 font-bold text-progressHighlightedColor': isHighlighted,
          'text-4 font-normal text-progressTextColor': !isHighlighted,
        },
        locator,
      )}
    >
      {value}
    </span>
  );
};
